import { UIKitIcon } from '../icon';

export const heartIcon: UIKitIcon = {
  name: 'heart',
  // tslint:disable-next-line: max-line-length
  data: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M21.15,6a6.14,6.14,0,0,1,4.34,10.49L16,26,6.5,16.49A6.14,'
  + '6.14,0,0,1,15.19,7.8l.8.8.81-.8A6.12,6.12,0,0,1,21.15,6" fill="none" stroke="inherit" stroke-miterlimit="10"/></svg>',
};
